import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { IPlanetDeviceWithFingotiDevice } from '../../types/PlanetDevice/PlanetDevice';
import { planetDeviceQueryKeys } from '../QueryKeys';

// import stub from "../../stubs/PlanetDevices.json";
// import { IPlanetDeviceWithFingotiDevice } from "../../types/PlanetDevice/PlanetDevice";

export default function usePlanetDevicesWithFingotiDevice() {
  const { get } = useApiHelper();

  const planetDevicesWithFingotiDevice = useQuery({
    queryKey: planetDeviceQueryKeys.allWithGateway(),
    queryFn: () =>
      get<IDefaultResponseWithData<IPlanetDeviceWithFingotiDevice>>(
        '/v1/device?includeGateway=true'
      ).then((res) => res.data.data),
    // queryFn: () => stub.planetDevices as IPlanetDeviceWithFingotiDevice[],
  });

  return {
    planetDevicesWithFingotiDevice,
  };
}
